export const documentType = {
  certificate: 'certificate',
  experience: 'experience',
  education: 'education',
  license: 'license',
  passport: 'passport',
  visa: 'visa',
}
